import { SettingsPage } from "@/components/v2/settings-page";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { PermissionsGrid } from "@/components/permissions-grid";
import { useAbility } from "@/hooks/use-ability";
import { useCurrentUser } from "@/hooks/use-current-user";

function formatRole(role: string | null | undefined): string {
  if (!role) return "—";
  return role
    .split("_")
    .map((s) => s.charAt(0).toUpperCase() + s.slice(1))
    .join(" ");
}

export default function V2SettingsProfilePage() {
  const currentUser = useCurrentUser();
  const ability = useAbility();

  return (
    <SettingsPage
      title="Profile"
      subtitle="Your personal information and account details."
    >
      <Card>
        <CardHeader>
          <CardTitle>Your Details</CardTitle>
          <CardDescription>Profile editing is coming soon.</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div>
            <p className="typo-label text-[color:var(--color-text-md)] mb-1">
              Email
            </p>
            <p className="typo-body text-[color:var(--color-text-hi)]">
              {currentUser?.email ?? "—"}
            </p>
          </div>
          <div>
            <p className="typo-label text-[color:var(--color-text-md)] mb-1">
              Role
            </p>
            <p className="typo-body text-[color:var(--color-text-hi)] capitalize">
              {currentUser?.accountRole ?? "—"}
            </p>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>My Permissions</CardTitle>
          <CardDescription>
            What you can do in Adva, derived from your role.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="flex flex-wrap gap-4">
            <div>
              <p className="typo-label text-[color:var(--color-text-md)] mb-1">
                System role
              </p>
              <p className="typo-body text-[color:var(--color-text-hi)]">
                {formatRole(currentUser?.systemRole)}
              </p>
            </div>
            {currentUser?.endUserRole ? (
              <div>
                <p className="typo-label text-[color:var(--color-text-md)] mb-1">
                  End-user role
                </p>
                <p className="typo-body text-[color:var(--color-text-hi)]">
                  {formatRole(currentUser.endUserRole)}
                </p>
              </div>
            ) : null}
          </div>
          {currentUser ? (
            <PermissionsGrid
              ability={ability}
              scope={{
                accountId: currentUser.accountId,
                businessId: currentUser.businessId || null,
                userId: currentUser.userId,
              }}
            />
          ) : null}
          <p className="text-xs text-[color:var(--color-text-md)]">
            Permissions are derived from your role and tenant scope. See ticket
            ADV-879 for the unified role model.
          </p>
        </CardContent>
      </Card>
    </SettingsPage>
  );
}
